import { render, staticRenderFns } from "./2.vue?vue&type=template&id=30c0a7b2&scoped=true&"
import script from "./2.vue?vue&type=script&lang=js&"
export * from "./2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c0a7b2",
  null
  
)

export default component.exports